import { render, staticRenderFns } from "./OrderEmployees.vue?vue&type=template&id=4b4dcd70&scoped=true&"
import script from "./OrderEmployees.vue?vue&type=script&lang=js&"
export * from "./OrderEmployees.vue?vue&type=script&lang=js&"
import style0 from "./OrderEmployees.vue?vue&type=style&index=0&id=4b4dcd70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4dcd70",
  null
  
)

export default component.exports